import { DESKTOP_NATIVE_ENGLISH } from "./desktop-native"

export const dict = {
  ...DESKTOP_NATIVE_ENGLISH,
  "session.location.unavailable": "Session location unavailable",
  "session.location.description": "Choose another directory to continue this session.",
  "session.location.choose": "Choose directory",
  "session.location.worktree": "Choose worktree",
  "session.location.worktreesFailed": "Failed to load worktrees",
  "session.location.moving": "Moving session…",
  "session.location.moveFailed": "Failed to move session",
  "server.action.authenticate": "Authenticate",
  "server.status.connecting": "Connecting over SSH…",
  "server.status.authentication": "Authentication required",
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.project": "Project",
  "command.category.provider": "Provider",
  "command.category.server": "Server",
  "command.category.session": "Session",
  "command.category.file": "File",
  "command.category.context": "Context",
  "command.category.model": "Model",
  "command.category.mcp": "MCP",
  "command.category.agent": "Agent",
  "command.category.permissions": "Permissions",
  "command.category.workspace": "Worktree",
  "command.category.settings": "Settings",
  "command.logs.export": "Export logs",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.project.open": "Open project",
  "command.project.copyID": "Copy Project ID",
  "command.provider.connect": "Connect provider",
  "command.provider.connect.description": "Sign in to OpenCode Go, OpenCode Console, or another model provider",
  "command.settings.open": "Open settings",
  "command.session.location.cycle": "Cycle session location",

  "command.palette": "Command palette",

  "command.session.new": "New session",
  "command.session.previous": "Previous session",
  "command.session.next": "Next session",
  "command.session.previous.unseen": "Previous unread session",
  "command.session.next.unseen": "Next unread session",
  "command.file.open": "Open file",
  "command.tab.close": "Close tab",
  "command.tab.reopenClosed": "Reopen closed tab",
  "command.context.addSelection": "Add selection to context",
  "command.context.addSelection.description": "Add selected lines from the current file",
  "command.input.focus": "Focus input",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.message.previous": "Previous message",
  "command.message.previous.description": "Go to the previous user message",
  "command.message.next": "Next message",
  "command.message.next.description": "Go to the next user message",
  "command.model.choose": "Choose model",
  "command.model.choose.description": "Select a different model",
  "command.mcp.toggle": "Toggle MCPs",
  "command.mcp.toggle.description": "Toggle MCPs",
  "command.agent.cycle": "Cycle agent",
  "command.agent.cycle.description": "Switch to the next agent",
  "command.agent.cycle.reverse": "Cycle agent backwards",
  "command.agent.cycle.reverse.description": "Switch to the previous agent",
  "command.model.variant.cycle": "Cycle thinking effort",
  "command.model.variant.cycle.description": "Switch to the next effort level",
  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",
  "command.permissions.autoaccept.enable": "Auto-accept permissions",
  "command.permissions.autoaccept.disable": "Stop auto-accepting permissions",
  "command.permissions.autoaccept.project": "Auto-accept permissions for this project",
  "command.session.undo": "Undo",
  "command.session.undo.description": "Undo the last message",
  "command.session.redo": "Redo",
  "command.session.redo.description": "Redo the last undone message",
  "command.session.compact": "Compact session",
  "command.session.compact.description": "Summarize the session to reduce context size",
  "command.session.fork": "Fork from message",
  "command.session.fork.description": "Create a new session from a previous message",
  "command.session.export": "Export session",
  "command.session.export.description": "Export the full session transcript as JSON",
  "command.session.import": "Import session",
  "command.session.copyID": "Copy Session ID",

  "palette.search.placeholder": "Search files, commands, and sessions",
  "palette.search.placeholder.home": "Search commands and sessions",
  "palette.empty": "No results found",
  "palette.group.commands": "Commands",
  "palette.group.files": "Files",
  "palette.group.recentSessions": "Recent sessions",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.group.popular": "Popular",
  "dialog.provider.group.other": "Other",
  "dialog.provider.custom.label": "Custom OpenAI-compatible provider",
  "dialog.provider.tag.recommended": "Recommended",
  "dialog.provider.opencode.note": "Curated models including Claude, GPT, Gemini and more",
  "dialog.provider.opencode.tagline": "Reliable optimized models",
  "dialog.provider.opencodeGo.tagline": "Low cost subscription for everyone",
  "dialog.provider.anthropic.note": "Direct access to Claude models via API key",
  "dialog.provider.copilot.note": "AI models for coding assistance via GitHub Copilot",
  "dialog.provider.openai.note": "GPT models for fast, capable general AI tasks",
  "dialog.provider.google.note": "Gemini models for fast, structured responses",
  "dialog.provider.openrouter.note": "Access all supported models from one provider",
  "dialog.provider.vercel.note": "Unified access to AI models with smart routing",

  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",
  "dialog.model.manage.description": "Customize which models appear in the model selector.",
  "dialog.model.chatgptPlan": "Using ChatGPT plan",
  "dialog.model.chatgptManageUsage": "Manage usage",

  "dialog.model.unpaid.freeModels.title": "Free models provided by OpenCode",
  "dialog.model.unpaid.addMore.title": "Add more models from popular providers",
  "dialog.model.unpaid.viewMoreProviders": "See 70+ more providers",

  "dialog.provider.viewAll": "Show more providers",
  "dialog.provider.accounts.count.one": "{{count}} account",
  "dialog.provider.accounts.count.other": "{{count}} accounts",
  "dialog.provider.accounts.add": "Add another account",
  "dialog.provider.accounts.connected": "Connected accounts",
  "dialog.provider.accounts.removeConfirm": "Remove {{account}}?",
  "dialog.provider.accounts.remove": "Remove",
  "dialog.provider.accounts.options": "{{account}} options",

  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.opencode.name": "OpenCode Console",
  "provider.connect.opencode.freeName": "OpenCode Free",
  "provider.connect.opencode.errorTitle": "Connect to OpenCode",
  "provider.connect.console.title": "Connecting to OpenCode Console",
  "provider.connect.console.titleGo": "Connecting to OpenCode Go",
  "provider.connect.console.intro": "Sign in with your OpenCode Console account to use the available models.",
  "provider.connect.console.continue": "Continue in the browser",
  "provider.connect.console.retry": "Try again",
  "provider.connect.console.serviceKeyDescription": "Connect using a service-account API key from OpenCode Console.",
  "provider.connect.console.instructions":
    "Continue in your browser. Confirm the code shown there matches the one below.",
  "provider.connect.console.deviceCode": "Device code",
  "provider.connect.console.deviceCode.label": "Device code: {{code}}",
  "provider.connect.console.waiting": "Waiting for confirmation…",
  "provider.connect.console.browserHint": "Browser didn't open?",
  "provider.connect.console.copyLink": "Copy sign-in link",
  "provider.connect.console.linkCopied": "Sign-in link copied",
  "provider.connect.console.copyFailed": "Couldn't copy the sign-in link. Open Console again to continue.",
  "provider.connect.console.openAgain": "Open Console again",
  "provider.connect.console.browserFailed":
    "We couldn't open your browser. Try again or copy the sign-in link to continue.",
  "provider.connect.console.expired": "This sign-in request has expired. Start again to get a new device code.",
  "provider.connect.console.denied": "Access was denied in Console. Try again when you're ready to connect.",
  "provider.connect.console.statusFailed": "Couldn't check authorization. Check your server connection and try again.",
  "provider.connect.console.startFailed": "Couldn't start sign-in. Check your server connection and try again.",
  "provider.connect.models.title": "Connected to {{provider}}",
  "provider.connect.models.description": "Choose a model to start with. You can switch models anytime.",
  "provider.connect.models.available": "Available models",
  "provider.connect.chatgptWelcome.title": "ChatGPT connected",
  "provider.connect.chatgptWelcome.description": "Eligible requests in OpenCode can use your ChatGPT plan.",
  "provider.connect.chatgptWelcome.usage": "Manage usage in ChatGPT settings",
  "provider.connect.chatgptWelcome.confirm": "Got it",
  "provider.connect.models.list": "Models available from {{provider}}",
  "provider.connect.chatgptUsageLimit.title": "ChatGPT usage limit reached",
  "provider.connect.chatgptUsageLimit.description": "Check your usage and limits in ChatGPT settings.",
  "provider.connect.chatgptUsageLimit.manage": "Manage usage",
  "provider.connect.chatgptUsageLimit.close": "Close",
  "provider.connect.console.refreshFailed":
    "Your account is connected, but we couldn't load your models. Try again to refresh them.",
  "provider.connect.console.connected": "OpenCode connected",
  "provider.connect.console.noModels":
    "Your account is connected, but this Console workspace has no available models. Check its setup in Console, then refresh.",
  "provider.connect.console.modelsLoading": "Your models are still loading. Refresh to check again.",
  "provider.connect.console.refresh": "Refresh models",
  "provider.connect.console.openingBrowser": "Opening browser…",
  "provider.connect.console.serviceAccount": "Service account?",
  "provider.connect.console.useApiKey": "Use API key",
  "provider.connect.remote.title": "Connecting on “{{server}}”",
  "provider.connect.remote.description":
    "Your OpenCode credentials will be stored on this server. Models will be available through this server.",
  "provider.connect.title.anthropicProMax": "Login with Anthropic",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.method.browser": "Browser",
  "provider.connect.method.headless": "Headless",
  "provider.connect.status.inProgress": "Authorization in progress…",
  "provider.connect.status.waiting": "Waiting for authorization…",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.error.unsupportedFields": "This authentication form contains unsupported fields",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.oauth.auto.confirmationCode.description":
    "Check that your browser shows the same code before you authorize.",
  "provider.connect.oauth.auto.description":
    "Your browser opens so you can sign in to {{provider}}. Come back here when you are done.",
  "provider.connect.oauth.code.description":
    "Your browser opens so you can sign in to {{provider}}. Paste the authorization code it gives you below.",
  "provider.connect.oauth.openBrowser": "Open browser",
  "provider.connect.oauth.expired": "Authorization expired",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",

  "provider.custom.title": "Custom provider",
  "provider.custom.unavailable": "Custom providers are unavailable on this server",
  "provider.custom.description.prefix": "Configure an OpenAI-compatible provider. See the ",
  "provider.custom.description.link": "provider config docs",
  "provider.custom.description.suffix": ".",
  "provider.custom.field.providerID.label": "Provider ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "Lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.field.name.label": "Display name",
  "provider.custom.field.name.placeholder": "My AI Provider",
  "provider.custom.field.baseURL.label": "Base URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API key",
  "provider.custom.field.apiKey.placeholder": "API key",
  "provider.custom.field.apiKey.description": "Optional. Leave empty if you manage auth via headers.",
  "provider.custom.models.label": "Models",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "Name",
  "provider.custom.models.name.placeholder": "Display Name",
  "provider.custom.models.remove": "Remove model",
  "provider.custom.models.add": "Add model",
  "provider.custom.headers.label": "Headers (optional)",
  "provider.custom.headers.key.label": "Header",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "Value",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "Remove header",
  "provider.custom.headers.add": "Add header",
  "provider.custom.error.providerID.required": "Provider ID is required",
  "provider.custom.error.providerID.format": "Use lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.error.providerID.exists": "That provider ID already exists",
  "provider.custom.error.name.required": "Display name is required",
  "provider.custom.error.baseURL.required": "Base URL is required",
  "provider.custom.error.baseURL.format": "Must start with http:// or https://",
  "provider.custom.error.required": "Required",
  "provider.custom.error.duplicate": "Duplicate",

  "provider.disconnect.toast.disconnected.title": "{{provider}} disconnected",
  "provider.disconnect.toast.disconnected.description": "{{provider}} models are no longer available.",
  "provider.disconnect.toast.noCredentials.description": "No removable credentials found for {{provider}}",
  "provider.disconnect.toast.failed.description": "Failed to disconnect {{provider}}.",

  "model.tag.free": "Free",
  "model.tag.latest": "Latest",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "text",
  "model.input.image": "image",
  "model.input.audio": "audio",
  "model.input.video": "video",
  "model.input.pdf": "pdf",
  "model.tooltip.allows": "Allows: {{inputs}}",
  "model.tooltip.context.label": "Context",
  "model.tooltip.inputs": "Inputs",
  "model.tooltip.model": "Model",
  "model.tooltip.provider": "Provider",
  "model.tooltip.reasoning": "Reasoning",
  "model.tooltip.reasoning.allowed": "Allows reasoning",
  "model.tooltip.reasoning.none": "No reasoning",
  "model.tooltip.context": "Context limit {{limit}}",

  "common.search.placeholder": "Search",
  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "common.loading.ellipsis": "…",
  "common.cancel": "Cancel",
  "common.clear": "Clear",
  "common.color.orange": "orange",
  "common.color.yellow": "yellow",
  "common.color.cyan": "cyan",
  "common.color.green": "green",
  "common.color.red": "red",
  "common.color.pink": "pink",
  "common.color.blue": "blue",
  "common.color.purple": "purple",
  "common.color.gray": "gray",
  "common.open": "Open",
  "common.connect": "Connect",
  "common.disconnect": "Disconnect",
  "common.continue": "Continue",
  "common.retry": "Try again",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.default": "Default",
  "common.attachment": "attachment",

  "prompt.placeholder.shell": "Enter shell command… {{example}}",
  "prompt.placeholder.normal": 'Ask anything… "{{example}}"',
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "session.child.promptDisabled": "Subagent sessions cannot be prompted.",
  "session.child.backToParent": "Back to main session.",

  "prompt.action.attachFile": "Add files",

  "prompt.toast.attachmentDuplicate.title": "This file has already been uploaded",
  "prompt.toast.uploading.percent": "{{percent}}%",
  "prompt.toast.uploading.cancelFile": "Cancel upload of {{filename}}",
  "prompt.toast.uploadFailed.title": "Upload failed",
  "prompt.toast.modelAgentRequired.title": "Select an agent and model",
  "prompt.toast.modelAgentRequired.description": "Choose an agent and model before sending a prompt.",
  "prompt.toast.unqueueable.title": "This prompt cannot be queued",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create session",
  "prompt.toast.shellSendFailed.title": "Failed to send shell command",
  "prompt.toast.commandSendFailed.title": "Failed to send command",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",

  "dialog.mcp.title": "MCPs",
  "dialog.mcp.description": "{{enabled}} of {{total}} enabled",
  "dialog.mcp.empty": "No MCPs configured",

  "mcp.status.connected": "connected",
  "mcp.status.failed": "failed",
  "mcp.status.needs_auth": "needs auth",
  "mcp.status.disabled": "disabled",
  "mcp.auth.interactiveForm": "MCP server {{name}} requires an interactive authentication form",

  "dialog.fork.empty": "No messages to fork from",

  "dialog.directory.action.selectFile": "Select file",
  "dialog.directory.action.selectFolder": "Select folder",
  "dialog.directory.root": "Root",
  "dialog.directory.parent": "Parent",
  "dialog.directory.readError": "Unable to read this folder",

  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking…",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.password": "Password",
  "dialog.server.add.passwordPlaceholder": "password",

  "server.connect.title": "Connect to a server",
  "server.connect.description": "Enter your server address and password to get started.",
  "server.connect.description.pairing": "Paste the pairing link from the server, or scan its QR code.",
  "server.connect.link": "Pairing link",
  "server.connect.link.placeholder": "http://192.168.1.2:4096/auth/connect/…",
  "server.connect.link.invalid":
    "Paste the full pairing link from opencode pair, or from Settings → Pairing on the server's computer.",
  "server.connect.password.prompt": "No pairing link?",
  "server.connect.password.use": "Use password",
  "server.connect.password.hint": "To see it, run opencode service get password on the server's computer.",
  "server.connect.link.prompt": "Have a pairing link?",
  "server.connect.link.use": "Use pairing link",
  "server.connect.button": "Connect",
  "server.connect.address.invalid": "Enter a valid HTTP or HTTPS server address.",
  "server.connect.failed": "Could not connect. Check the server address and password, then try again.",
  "server.connect.pair.link": "Run this command on the server's computer to get a pairing link and QR code.",
  "server.connect.scan": "Scan QR code",
  "server.connect.scan.description": "Point your camera at the QR code shown by opencode pair.",
  "server.connect.scan.invalid": "This is not an OpenCode pairing code. Scan the code shown by opencode pair.",
  "server.connect.scan.failed": "This browser could not read the QR code. Enter your connection details manually.",
  "server.connect.link.expired": "This pairing link expired or was already used. Run opencode pair to get a new one.",
  "server.connect.link.unreachable":
    "Could not reach {{url}}. Check that this device can reach the server, then try again.",
  "server.connect.link.legacy":
    "This pairing code is from an older version of OpenCode. Update OpenCode on the server, then run opencode pair again.",
  "server.connect.camera": "Pairing camera",
  "server.connect.camera.starting": "Opening camera…",
  "server.connect.mixedContent":
    "Could not connect to this HTTP server from an HTTPS page. Use an HTTPS server address instead.",
  "server.connect.camera.native": "This page cannot use the camera over HTTP. Paste the pairing link above.",
  "server.connect.camera.unavailable":
    "No camera is available to this browser. Enter your connection details manually.",
  "server.connect.camera.error":
    "Could not open the camera. Allow camera access or enter your connection details manually.",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.signedOut":
    "Your sign-in for this server is no longer valid. Paste a new pairing link, or enter the server password.",

  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.remove": "Remove",
  "dialog.server.menu.hide": "Hide from project list",
  "dialog.server.menu.show": "Show in project list",

  "server.row.incompatible":
    "This server is running OpenCode {{version}}, which isn't compatible with this app. Upgrade it to OpenCode V2 to continue.",

  "dialog.project.edit.title": "Edit project",
  "dialog.project.edit.icon": "Icon",
  "dialog.project.edit.icon.alt": "Project icon",
  "dialog.project.edit.color": "Color",
  "dialog.project.edit.color.select": "Select {{color}} color",
  "dialog.project.edit.worktree.startup": "Worktree startup script",
  "dialog.project.edit.worktree.startup.placeholder": "e.g. bun install",

  "dialog.usageExceeded.dontShowAgain": "Don't show again",

  "toast.permissions.autoaccept.on.title": "Auto-accepting permissions",
  "toast.permissions.autoaccept.on.description": "Permission requests will be automatically approved",
  "toast.permissions.autoaccept.project.title": "Auto-accepting permissions for this project",
  "toast.permissions.autoaccept.project.description":
    "Permission requests in this project will be automatically approved",
  "toast.permissions.autoaccept.off.title": "Stopped auto-accepting permissions",
  "toast.permissions.autoaccept.off.description": "Permission requests will require approval",

  "toast.file.loadFailed.title": "Failed to load file",
  "toast.file.listFailed.title": "Failed to list files",

  "toast.context.noLineSelection.title": "No line selection",
  "toast.context.noLineSelection.description": "Select a line range in a file tab first.",

  "toast.session.export.success.title": "Session exported",
  "toast.session.export.success.description": "Saved session to {{filename}}",
  "toast.session.export.failed.title": "Failed to export session",
  "toast.session.export.failed.description": "An error occurred while exporting the session",
  "toast.session.copyID.failed.title": "Failed to copy session ID",
  "toast.session.copyID.failed.description": "An error occurred while copying the session ID",
  "toast.project.copyID.failed.title": "Failed to copy project ID",
  "toast.project.copyID.failed.description": "An error occurred while copying the project ID",

  "toast.project.reloadFailed.title": "Failed to reload {{project}}",
  "toast.migration.failed.title": "Data migration failed",
  "toast.migration.progress.clearingOldEvents": "Clearing old events",
  "toast.migration.progress.migratingSessions": "Migrating sessions",
  "toast.migration.progress.migratingSessions.current": "Migrating sessions {{current}}",
  "toast.migration.progress.migratingSessions.progress": "Migrating sessions {{current}}/{{total}}",
  "toast.migration.progress.working": "Migrating data",
  "toast.migration.progress.working.current": "Migrating data {{current}}",
  "toast.migration.progress.working.progress": "Migrating data {{current}}/{{total}}",

  "error.page.title": "Something went wrong",
  "error.page.title.status": "Server request failed",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.description.status": "The server returned an HTTP {{status}} response.",
  "error.page.description.localServerStartup": "An error occurred while starting the local server.",
  "error.page.details.label": "Error Details",
  "error.page.action.restart": "Restart",
  "error.page.action.reload": "Reload",
  "error.page.action.report": "Report Error",
  "error.page.action.reported": "Error Reported",
  "error.page.action.exportLogs": "Export Logs",
  "error.page.action.checking": "Checking…",
  "error.page.action.checkUpdates": "Check for updates",
  "error.page.action.updateTo": "Update to {{version}}",
  "error.page.circular": "[Circular]",
  "error.page.report.prefix": "Please report this error to the OpenCode team",
  "error.page.report.discord": "on Discord",
  "error.page.version": "Version: {{version}}",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.serverSync.connectFailed": "Could not connect to server. Is there a server running at `{{url}}`?",
  "error.serverSDK.noServerAvailable": "No server available",
  "error.serverSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",

  "error.chain.unknown": "Unknown error",
  "error.server.invalidConfiguration": "Invalid configuration",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (opencode.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, OpenCode does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Session error",
  "notification.session.error.fallbackDescription": "An error occurred",

  "home.title": "Home",
  "home.projects": "Projects",
  "home.projects.all": "All projects",
  "home.project.add": "Add project",
  "home.project.missing.title": "Project folder not found",
  "home.project.missing.description": "The folder for {{name}} no longer exists.",
  "home.recentlyClosed": "Recently closed",
  "home.server.collapse": "Collapse server projects",
  "home.server.expand": "Expand server projects",
  "home.sessions.search.placeholder": "Search sessions",
  "home.sessions.search.placeholder.scoped": "Search sessions in {{scope}}",
  "home.sessions.search.sessions": "Sessions",
  "home.sessions.search.noResults": "No sessions found for {{query}}",
  "home.sessions.empty": "Nothing here yet",
  "home.sessions.empty.description": "Create a session to get started",
  "home.sessions.group.today": "Today",
  "home.sessions.group.yesterday": "Yesterday",
  "home.sessions.group.older": "Older",
  "home.providerTip": "Connect to 75+ providers to use other models, including Claude, GPT, Gemini, etc",
  "home.workspaceTip": "Start next session in a new workspace to keep changes isolated",

  "session.tab.session": "Session",
  "session.tab.more": "More...",
  "session.view.select": "Session view",
  "session.tab.add": "Add tab",
  "session.tab.unknown": "Unknown Session",
  "session.panel.reviewAndFiles": "Review and files",
  "session.error.notFound": "This session cannot be found",
  "session.error.notFound.description": "This tab points to a session that no longer exists on this server.",
  "session.error.notFound.closeTab": "Close Tab",
  "session.error.incompatible": "This server version isn't supported",
  "session.error.incompatible.description":
    "{{server}} is running OpenCode {{version}}, which isn't compatible with this app. Upgrade the server to OpenCode V2 to continue.",
  "session.background.moveRunning": "Move to background",
  "session.background.moveInline": "Press {{keybind}} to move running work to the background",
  "command.session.background": "Move to background",
  "session.queue.count.one": "{{count}} queued",
  "session.queue.count.other": "{{count}} queued",
  "session.queue.steer": "Steer",
  "session.queue.send": "Send",
  "session.queue.steerTooltip": "Send without interrupting",
  "session.queue.remove": "Remove",
  "session.queue.undo": "Undo",
  "session.queue.undoShell": "Leave shell mode before undoing a queued prompt",
  "session.queue.reorder": "Reorder queued prompt",
  "session.queue.reverted": "Redo the revert before you reorder or edit queued prompts",
  "session.queue.attachments.one": "{{count}} attachment",
  "session.queue.attachments.other": "{{count}} attachments",
  "session.timeline.working": "Working",
  "session.running.working.one": "{{count}} working",
  "session.running.working.other": "{{count}} working",
  "session.running.running.one": "{{count}} running",
  "session.running.running.other": "{{count}} running",
  "session.running.additionalWorking.one": "+{{count}} working",
  "session.running.additionalWorking.other": "+{{count}} working",
  "session.running.additionalRunning.one": "+{{count}} running",
  "session.running.additionalRunning.other": "+{{count}} running",
  "session.running.stop.subagent": "Interrupt subagent",
  "session.running.stop.shell": "Kill shell command",

  "session.files.selectToOpen": "Select a file to open",

  "session.messages.loading": "Loading messages…",
  "session.messages.jumpToLatest": "Jump to latest",

  "session.question.progress": "{{current}} of {{total}} questions",
  "session.question.title": "Question",
  "session.elicitation.selectPlaceholder": "Select an option",
  "session.websearch.title": "Third-party web search",
  "session.websearch.description": "Select the search provider agents use to search the web",
  "session.websearch.provider": "Search provider",
  "session.websearch.any": "Any",
  "session.websearch.disable": "Don’t use search",
  "session.websearch.enable": "Enable",
  "session.websearch.loadFailed": "Could not load search providers.",
  "session.websearch.empty": "No search providers available.",
  "session.websearch.failed": "Could not save your choice. Please try again.",
  "session.websearch.retry": "Retry",
  "session.question.minimize": "Minimize question",
  "session.question.restore": "Restore question",

  "session.new.project.new": "New project",
  "session.new.project.search": "Search projects",
  "session.new.project.add": "Add project",
  "session.new.worktree.creating": "Creating worktree",
  "session.new.workspace.runIn": "Run session in",
  "session.new.workspace.triggerLocal": "Local",
  "session.new.workspace.local": "Local repository",
  "session.new.workspace.existingLabel": "Worktree",
  "session.new.git.none": "No Git",

  "session.search.placeholder": "Find...",
  "session.search.noResults": "No matches",
  "session.header.open.finder": "Finder",
  "session.header.open.fileExplorer": "File Explorer",
  "session.header.open.fileManager": "File Manager",
  "session.header.reveal.finder": "Reveal in Finder",
  "session.header.reveal.fileExplorer": "Reveal in File Explorer",
  "session.header.reveal.containingFolder": "Open containing folder",

  "settings.tab.servers": "Servers",
  "settings.extensions.tab.plugins": "Plugins",

  "common.copied": "Copied",

  "titlebar.tabs": "Tabs",
  "titlebar.channel.local": "Local",
  "titlebar.channel.dev": "Dev",
  "titlebar.channel.beta": "Beta",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "common.moreOptions": "More options",
  "common.learnMore": "Learn more",
  "common.rename": "Rename",
  "common.export": "Export",
  "common.reset": "Reset",
  "common.archive": "Archive",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.loadMore": "Load more",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.settings": "Settings",
  "sidebar.help": "Help",
  "sidebar.project.recentSessions": "Recent sessions",
  "sidebar.project.clearNotifications": "Clear notifications",

  "settings.section.server": "Server",
  "settings.backToApp": "Back to app",
  "settings.backToSettings": "Back to settings",
  "settings.backToProjects": "Back to projects",
  "settings.search.placeholder": "Search",
  "settings.search.results": "Settings results",
  "settings.search.group.pages": "Pages",
  "settings.search.group.settings": "Settings",
  "settings.search.group.projects": "Projects",
  "settings.search.group.servers": "Servers",
  "settings.search.result": "{{title}}, {{scope}}, {{page}}",
  "settings.search.page": "{{title}}, {{scope}}",
  "settings.search.result.unscoped": "{{title}}, {{page}}",
  "settings.search.empty": "No results for {{query}}",
  "settings.search.empty.query": '"{{query}}"',
  "settings.search.refine": "Narrow your search to see more specific results.",
  "settings.tab.preferences": "Preferences",
  "settings.tab.shortcuts": "Shortcuts",
  "settings.tab.notifications": "Notifications",
  "settings.tab.projects": "Projects",
  "settings.tab.extensions": "Extensions",
  "settings.tab.experimental": "Experimental",
  "settings.experimental.description": "Try experimental features",
  "settings.guiExtensions.title": "Extensions",
  "settings.guiExtensions.description": "Built-in GUI extensions in this window. Development builds only.",
  "settings.guiExtensions.reload": "Reload",
  "settings.guiExtensions.status.loading": "Loading",
  "settings.guiExtensions.status.active": "Active",
  "settings.guiExtensions.status.failed": "Failed",
  "settings.guiExtensions.status.disabled": "Disabled",
  "settings.guiExtensions.status.blocked": "Blocked",
  "settings.tab.about": "About",
  "settings.about.version": "Version {{version}}",
  "settings.about.devVersion": "development",
  "settings.about.license": "Released under the MIT License",
  "settings.about.writtenByNames": "Written by {{names}}",
  "settings.about.illustratedByNames": "Illustrated by {{names}}",
  "settings.about.otherContributor.one": "{{count}} other",
  "settings.about.otherContributor.other": "{{count}} others",
  "settings.about.firstPublished": "First published in Missouri, USA",
  "settings.about.firstIllustrated": "First illustrated in London, England",
  "settings.about.website": "www.opencode.ai",
  "settings.about.description": "OpenCode, the open source coding agent",
  "settings.about.trademark": "OpenCode is a registered trademark of Anomaly Innovations, Inc.",
  "settings.about.typeset": "Typeset in Inter and IBM Plex Mono",
  "settings.about.notices.title": "Third-party notices",
  "settings.about.notices.description": "OpenCode includes the following open source software.",
  "settings.about.notices.license": "License text",
  "settings.about.notices.fonts.title": "Fonts in the Office previews",
  "settings.about.notices.fonts.description":
    "Each family is distributed under the SIL Open Font License 1.1, with the copyright lines below.",
  "settings.about.notices.eigenpal": "Portions of BetterOffice derive from it.",
  "settings.about.notices.loadFailed": "Could not load the third-party notices",
  "settings.about.notices.crates.title": "Rust crates in the Office engines",
  "settings.about.notices.crates.description":
    "BetterOffice compiles these crates into its Word, Excel and PowerPoint engines. Where a crate offers a choice of licenses, the highlighted license applies.",
  "settings.about.notices.crates.licenses": "License texts",
  "settings.about.notices.crates.count.one": "{{count}} crate",
  "settings.about.notices.crates.count.other": "{{count}} crates",
  "settings.about.notices.crates.appliesTo": "Applies to {{names}}",
  "settings.about.tagline": "AI can’t build great software, without you",
  "settings.about.copyright": "© Anomaly Innovations, Inc.",
  "settings.preferences.description": "Customize preferences and theme and default behavior",
  "settings.appearance.description": "Customize theme and fonts",
  "settings.appearance.row.tabs.title": "Tabs",
  "settings.appearance.row.tabs.description": "Choose how session tabs are arranged",
  "settings.appearance.row.tabs.horizontal": "Horizontal",
  "settings.appearance.row.tabs.vertical": "Vertical",
  "settings.notifications.description": "Choose when to receive notifications and hear sounds",
  "settings.shortcuts.description": "Customize shortcuts for common actions",
  "settings.servers.description": "Manage server connections",
  "settings.server.description": "Manage this server’s connection and preferences",
  "settings.server.section.connection": "Connection",
  "settings.server.preferences.websearch.title": "Third-party search",
  "settings.server.preferences.websearch.description": "Select the search provider agents use to search the web",
  "settings.projects.title": "Projects",
  "settings.projects.description": "Manage projects and their settings",
  "settings.projects.empty": "No projects found",
  "settings.projects.empty.title": "No projects yet",
  "settings.projects.empty.description": "Add a project to get started",
  "settings.projects.search.placeholder": "Search projects",
  "settings.extensions.description": "Manage extensions available on this server",
  "settings.extensions.tab.mcps": "MCPs",
  "settings.extensions.tab.skills": "Skills",
  "settings.extensions.availableAll": "Available to all projects",
  "settings.extensions.manageConfig": "Manage in opencode.json",
  "settings.extensions.addSkills": "How to add skills",
  "project.settings.title": "Edit project",
  "project.settings.autoAccept.description": "Approve this project's permission requests without asking",
  "project.settings.autoAccept.default.on": "Use default (On)",
  "project.settings.autoAccept.default.off": "Use default (Off)",
  "project.settings.autoAccept.on": "On",
  "project.settings.autoAccept.off": "Off",
  "project.settings.name.title": "Project name",
  "project.settings.name.description": "The name shown for this project throughout OpenCode",
  "project.settings.icon.description": "Recommended: 128×128px. Click or drag to upload an image.",
  "project.settings.color.description": "Used for the project icon when no custom image is set",
  "project.settings.worktree.startup.description": "Runs once after creating a new worktree",
  "project.settings.worktree.startup.hint.base": "Use $OPENCODE_WORKTREE_BASE for the base worktree.",
  "project.settings.worktree.startup.hint.new": "Use $OPENCODE_WORKTREE_PATH for the new worktree.",
  "project.settings.folderMissing.title": "Project folder not found",
  "project.settings.folderMissing.description": "Restore the folder or close this project.",
  "project.settings.extensions.description": "View extensions available to this project",
  "project.settings.extensions.tab.lsps": "LSPs",
  "project.settings.extensions.added": "Added to this project",
  "project.settings.extensions.shared": "Shared with all projects",
  "project.settings.extensions.empty.mcps.title": "No MCPs yet",
  "project.settings.extensions.empty.mcps.description": "MCPs available to OpenCode will appear here",
  "project.settings.extensions.empty.plugins.title": "No plugins yet",
  "project.settings.extensions.empty.plugins.description": "Plugins available to OpenCode will appear here",
  "project.settings.extensions.empty.skills.title": "No skills yet",
  "project.settings.extensions.empty.skills.description": "Skills available to OpenCode will appear here",
  "project.settings.extensions.lsp.description": "Auto-detected from file types",
  "project.settings.extensions.lsp.configured": "Configured language servers",
  "project.settings.extensions.lsp.status.enabled": "Enabled in config",
  "project.settings.extensions.lsp.status.disabled": "Disabled in config",
  "project.settings.extensions.lsp.empty.title": "No language servers configured",
  "project.settings.extensions.lsp.empty.description": "Language servers configured for this project will appear here",
  "project.settings.extensions.lsp.disabled.title": "Language servers disabled",
  "project.settings.extensions.lsp.disabled.description": "LSP is disabled in this project’s configuration",
  "project.settings.extensions.lsp.loadFailed": "Could not load language server configuration",
  "project.settings.extensions.lsp.retry": "Retry",

  "settings.general.section.appearance": "Appearance",
  "settings.general.section.general": "General",
  "settings.general.section.notifications": "Desktop notifications",
  "settings.general.section.sounds": "Sound effects",

  "settings.timeline.title": "Timeline",
  "settings.timeline.detail": "Timeline detail",
  "settings.timeline.description": "Choose how much detail appears in the session timeline.",
  "settings.timeline.summary": "{{preset}}:",
  "settings.timeline.preset.everything": "Everything",
  "settings.timeline.preset.detailed": "Detailed",
  "settings.timeline.preset.compact": "Compact",
  "settings.timeline.preset.quiet": "Quiet",
  "settings.timeline.preset.text-only": "Messages only",
  "settings.timeline.description.everything": "Show all activity separately. Expand shell output, edits, and thinking.",
  "settings.timeline.description.detailed":
    "Expand shell output and edits. Show subagents separately and group other activity.",
  "settings.timeline.description.compact": "Group all activity with details collapsed.",
  "settings.timeline.description.quiet": "Group edits and subagents. Hide other activity.",
  "settings.timeline.description.text-only": "Hide all activity.",
  "settings.timeline.description.custom": "Uses advanced settings.",
  "settings.timeline.custom": "Custom",
  "settings.timeline.row.turnDiffs.title": "Changed files",
  "settings.timeline.row.turnDiffs.description": "List the files each turn changed when it finishes",
  "settings.timeline.advanced": "Advanced",
  "settings.timeline.advanced.description": "Set placement and details for each activity category.",
  "settings.timeline.group": "Group",
  "settings.timeline.collapse": "Collapse",
  "settings.timeline.visibility.show": "Show",
  "settings.timeline.visibility.hide": "Hide",
  "settings.timeline.visibility.label": "{{activity}} visibility",
  "settings.timeline.grouped.label": "{{activity}} grouped",
  "settings.timeline.collapsed.label": "{{activity}} collapsed",
  "settings.timeline.category.shell": "Shell",
  "settings.timeline.category.edit": "Edits",
  "settings.timeline.category.thinking": "Thinking",
  "settings.timeline.category.subagents": "Subagents",
  "settings.timeline.category.notices": "Notices",
  "settings.timeline.category.tools": "Other tools",

  "settings.general.row.language.title": "Language",
  "settings.general.row.language.description": "Change the display language for OpenCode",
  "settings.general.row.shell.title": "Terminal shell",
  "settings.general.row.shell.description": "Shell used by the terminal and agent tools",
  "settings.general.row.shell.autoDefault": "Auto (Default)",
  "settings.general.row.shell.terminalOnly": "terminal only",
  "settings.general.row.terminalPlacement.title": "Terminal placement",
  "settings.general.row.terminalPlacement.description": "Choose where the terminal opens in sessions",
  "settings.general.row.terminalPlacement.side": "Side",
  "settings.general.row.terminalPlacement.bottom": "Bottom",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether OpenCode follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how OpenCode is themed.",
  "settings.general.row.font.title": "Code Font",
  "settings.general.row.font.description": "Customise the font used in code blocks",
  "settings.general.row.terminalFont.title": "Terminal Font",
  "settings.general.row.terminalFont.description": "Customise the font used in the terminal",
  "settings.general.row.uiFont.title": "UI Font",
  "settings.general.row.uiFont.description": "Customise the font used throughout the interface",
  "settings.general.row.mobileTitlebarBottom.title": "Bottom navigation",
  "settings.general.row.mobileTitlebarBottom.description": "Place the title bar at the bottom of the screen on mobile",
  "settings.general.row.showCustomAgents.title": "Show agent",
  "settings.general.row.showCustomAgents.description":
    "Switch between agents in the composer. When hidden, defaults to Build agent.",
  "settings.general.row.followUpBehavior.title": "Follow-up behavior",
  "settings.general.row.followUpBehavior.description":
    "Choose whether to queue follow-ups or steer the current turn. Use {{keybind}} to switch.",
  "settings.general.row.followUpBehavior.queue": "Queue",
  "settings.general.row.followUpBehavior.steer": "Steer",
  "settings.general.row.pinchZoom.title": "Pinch to zoom",
  "settings.general.row.pinchZoom.description": "Allow trackpad pinch and Ctrl-scroll gestures to zoom",

  "sound.option.none": "None",
  "sound.option.alert01": "Alert 01",
  "sound.option.alert02": "Alert 02",
  "sound.option.alert03": "Alert 03",
  "sound.option.alert04": "Alert 04",
  "sound.option.alert05": "Alert 05",
  "sound.option.alert06": "Alert 06",
  "sound.option.alert07": "Alert 07",
  "sound.option.alert08": "Alert 08",
  "sound.option.alert09": "Alert 09",
  "sound.option.alert10": "Alert 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when the agent is complete or needs attention",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when an error occurs",

  "settings.general.sounds.agent.title": "Agent",
  "settings.general.sounds.agent.description": "Play sound when the agent is complete or needs attention",
  "settings.general.sounds.permissions.title": "Permissions",
  "settings.general.sounds.permissions.description": "Play sound when a permission is required",
  "settings.general.sounds.errors.title": "Errors",
  "settings.general.sounds.errors.description": "Play sound when an error occurs",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.unassigned": "Unassigned",
  "settings.shortcuts.pressKeys": "Press keys",
  "settings.shortcuts.search.placeholder": "Search shortcuts",

  "settings.shortcuts.group.general": "General",
  "settings.shortcuts.group.session": "Session",
  "settings.shortcuts.group.navigation": "Navigation",
  "settings.shortcuts.group.modelAndAgent": "Model and agent",
  "settings.shortcuts.group.terminal": "Terminal",
  "settings.shortcuts.group.prompt": "Prompt",

  "settings.providers.title": "Providers",
  "settings.providers.description": "Connect and manage model providers",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.connected.environmentDescription": "Connected from your environment variables",
  "settings.providers.account.manage": "Manage {{provider}} accounts",
  "settings.providers.account.group": "Accounts",
  "settings.providers.account.add": "Add account",
  "settings.providers.account.name": "Account name",
  "settings.providers.account.switched.title": "{{provider}} account switched",
  "settings.providers.account.switched.description": "Now using {{account}}.",
  "settings.providers.account.removed.title": "{{account}} removed",
  "settings.providers.account.removed.description": "{{provider}} will no longer use this account.",
  "settings.providers.console.available.one": "{{count}} provider available",
  "settings.providers.console.available.other": "{{count}} providers available",
  "settings.providers.section.popular": "Popular providers",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.account": "Account",
  "settings.providers.tag.other": "Other",
  "settings.models.title": "Models",
  "settings.models.description": "Choose which models appear in model picker",
  "settings.models.enableAll": "Enable all models",
  "settings.models.disableAll": "Disable all models",

  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, and patches",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.todowrite.title": "Todo Write",
  "settings.permissions.tool.todowrite.description": "Update the todo list",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.delete.failed.title": "Failed to delete session",
  "session.delete.title": "Delete session",
  "session.delete.confirm": 'Delete session "{{name}}"?',
  "session.delete.button": "Delete session",

  "workspace.new": "New worktree",
  "common.viewAll": "View all",
  "session.new.workspace.local.tooltip": "Uses project’s current checkout",
  "session.new.workspace.new.tooltip": "Creates isolated copy from current checkout",
  "session.new.workspace.fromBranch": "from {{branch}}",
  "session.new.workspace.branch.search.placeholder": "Search branches",
  "session.new.workspace.trigger.tooltip": "Select where to run session",
  "session.new.workspace.search.placeholder": "Search worktrees",
  "session.new.workspace.search.empty": "No matching worktrees",
  "settings.tab.workspaces": "Worktrees",
  "settings.workspaces.description": "Review worktrees and manage disk usage",
  "settings.workspaces.filter.all": "All projects",
  "settings.workspaces.empty": "No worktrees yet",
  "settings.workspaces.empty.description": "Worktrees created in OpenCode will appear here",
  "settings.workspaces.count.one": "{{count}} worktree",
  "settings.workspaces.count.other": "{{count}} worktrees",
  "settings.workspaces.sessions.one": "{{count}} session in {{project}}",
  "settings.workspaces.sessions.other": "{{count}} sessions in {{project}}",
  "settings.workspaces.sessions.filtered.one": "{{count}} session",
  "settings.workspaces.sessions.filtered.other": "{{count}} sessions",
  "settings.workspaces.lastActiveSession": "Last active session",
  "settings.workspaces.deleteAll": "Delete all worktrees",
  "settings.workspaces.deleteAll.confirm.one": "This will permanently delete {{count}} selected worktree.",
  "settings.workspaces.deleteAll.confirm.other": "This will permanently delete {{count}} selected worktrees.",
  "settings.workspaces.deleteWithoutSessions": "Delete worktrees without sessions",
  "settings.workspaces.deleteWithoutSessions.confirm.one":
    "This will permanently delete {{count}} worktree without linked sessions.",
  "settings.workspaces.deleteWithoutSessions.confirm.other":
    "This will permanently delete {{count}} worktrees without linked sessions.",
  "settings.workspaces.deleteWithoutSessions.warning":
    "Worktrees with unmerged changes or active locations will be kept.",
  "settings.workspaces.delete.button": "Delete worktrees",
  "settings.workspaces.delete.warning": "This permanently deletes the worktree and its branch.",
  "settings.workspaces.deleteAll.warning":
    "Worktrees with unmerged changes, linked sessions, or active locations will be kept.",
  "settings.workspaces.delete.blocked.active": "The active worktree cannot be deleted.",
  "settings.workspaces.delete.blocked.linked":
    "Linked sessions will remain, but their working directory will no longer exist.",
  "settings.permissions.autoAccept.default.description":
    "Approve permission requests without asking. Projects can override this in their settings.",
  "settings.workspaces.default.title": "Default environment",
  "settings.workspaces.default.description": "Choose where new sessions start",
  "settings.workspaces.default.lastUsed": "Last used per project",
  "settings.workspaces.default.local": "Local directory",
  "settings.workspaces.default.new": "New worktree",
  "workspace.lifecycle.deleting": "Deleting…",
  "workspace.onboarding.title": "Isolate sessions with worktrees",
  "workspace.onboarding.description": "Each gets its own checkout",
  "session.summary.basedOn": "Based on {{branch}}",
  "session.summary.mcp.prepareFailed": "Could not prepare MCP servers",
  "session.summary.mcp.unavailable": "MCP server {{name}} is not available in this worktree.",
  "session.summary.mcp.signInBeforeSend": "Sign in to {{name}} before sending the prompt.",
  "session.summary.mcp.notReady": "MCP server {{name}} is not ready. Resolve its connection before sending the prompt.",
  "workspace.delete.failed.title": "Failed to delete worktree",
  "workspace.status.checking": "Checking for unmerged changes…",
  "workspace.status.error": "Unable to verify git status.",
  "workspace.status.dirty": "Unmerged changes will be lost.",
  "workspace.delete.confirm": "Delete “{{name}}”?",
  "workspace.delete.location": "Location",
  "workspace.delete.button": "Delete worktree",
}

export default dict
